import { createSlice } from "@reduxjs/toolkit";

const dashboard = createSlice({
    name: 'dashboard',
    initialState: {},
    reducers: {
        addDashboard: (state, action) => {
            return { ...action.payload }
        }
    }
});

export const { addDashboard } = dashboard.actions;
export default dashboard.reducer;